import React from "react";
import EntityForm from "../EntityForm/EntityForm";

class LegalInfoForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  getFields(fields) {
    return fields && fields.form;
  }

  handleSubmit({ formValues }) {
    console.log("submitted ");
    const { config } = this.props;

    //TODO: handle case when there's an original entity
    //TODO: this could be handled in a generic way.
    const { id, ...otherFormValues } = formValues;
    const entity = {
      ...otherFormValues,
    };

    if (
      config.hasOwnProperty("translation") &&
      config.translation &&
      config.translation.hasOwnProperty("fieldName")
    ) {
      const translationField = config.translation.fieldName;
      const translationValues =
        (formValues.hasOwnProperty(translationField) && formValues[translationField]) || [];
      entity[config.translation.entityProperty] = translationValues.map(translation => {
        return {
          locale: translation.locale,
          text: translation.text,
        };
      });
    }

    if (id !== "" && id !== " " && id !== null && typeof formValues.id !== "undefined") {
      entity.id = formValues.id;
    }

    this.props.onSubmitEntity({
      entity,
    });
  }

  /* Handle Errors */
  render() {
    const { name, validation, fields, renderers, translation, entities } = this.props.config;
    const { locales, entity, entityError, entityResult, loading, getListPath } = this.props;
    const { getFields, handleSubmit } = this;
    return (
      <EntityForm
        loading={loading}
        name={name}
        entity={entity}
        entities={entities}
        validation={validation}
        renderers={renderers}
        fields={getFields(fields)}
        locales={locales}
        translation={translation}
        onSubmit={handleSubmit}
        entityError={entityError}
        entityResult={entityResult}
        getListPath={getListPath}
      />
    );
  }
}

LegalInfoForm.propTypes = {};

LegalInfoForm.defaultProps = {
  locales: ["es", "ca", "en", "fr", "it", "de"],
};

export default LegalInfoForm;
